import { render } from "./SaveProgress.vue?vue&type=template&id=066b981b&scoped=true"
import script from "./SaveProgress.vue?vue&type=script&lang=js"
export * from "./SaveProgress.vue?vue&type=script&lang=js"

import "./SaveProgress.vue?vue&type=style&index=0&id=066b981b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066b981b"]])

export default __exports__